import Axios, { AxiosResponse } from 'axios';
import AxiosDefaultRequestConfig from './AxiosDefaultRequestConfig';
import AxiosPostProcessor from './AxiosPostProcessor';
import store from './store';

export interface UserEventProperties {
    [key: string]: string | number | boolean | null | undefined;
}

export class UserEventServiceStatic {
    record(type: string, properties: UserEventProperties = {}): Promise<AxiosResponse<void>> {
        if(!store.getters.isUserLoggedIn) {
            return Promise.resolve({} as AxiosResponse<void>)
        }
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/user/event`
        const policy = store.getters.policy
        return AxiosPostProcessor.postProcess(Axios.post<void>(url, {
            type,
            policyVersion: policy?.version ?? null,
            properties
        }, AxiosDefaultRequestConfig.merge({ })));
    }

    recordSafe(type: string, properties: UserEventProperties = {}) {
        this.record(type, properties).catch(error => console.warn('Could not record user event', type, error))
    }
}

const UserEventService = new UserEventServiceStatic();
export default UserEventService;
